module.exports = {
  app: {
    allapp: "All applications",
    ok: "Ok",
    entrust: " Add entrust",
    BackTolist: "Back to list",
    mailbox: "email",
    phone: "phone",
    modify: "modify",
    saveok:
      "Save classification successfully, do you want to return to the application list?",
    deleteok: "Are you sure you want to delete?",
    SendCode: "Send",
    SendAgain: "Send again",
    reSendCode: "Resend",
    applicant: "applicant",
    TaskName: "Task name",
    ApprovalType: "Approval type",
    state: "state",
    operation: "operation",
    details: "details",
    FormFilling: "Form filling",
    cancel: "cancel",
    classificationName: "Please fill in the classification name！",
    ClassificationAlreadyExists: "Classification already exists",
    categories: "No more than 10 categories",
    PermissionSelection: "jurisdiction",
    reason: "reason",
    Submit: "Submit",
    PleaseSelect: "Please select",
    clickCode: "Send verification code",
    notBindPhone:
      "The mobile phone number has not been bound yet. Please bind the mobile phone first!",
  },

  describe: {
    login: "SIGN IN",
    inputPwd: "Please enter the user password",
    inputUser: "Enter one user name",
    auth: "BNBU Authentication Service",
    auth1: "SINGLE SIGN ON",
    // auth2:"Warm tips: Please enter the account password to verify login",
    // tips_01:"IMPORTANT TIPS",
    // tips_02:"Before you log in, be sure to verify the web address of the web page and make sure it is started",
    // tips_03:"Log out and close all browser windows after accessing the service",
    required: "Mandatory Field",
    phoneNumber: "Please enter your mobile phone number",
    phoneVerificationCode: "verification code",
    GraphicVerificationCode: "verification code",
    AppManage: "App Manage",
    SwitchTo: "Switch to",
    ioaQuickLogon: "IOA Quick Logon",
    AccountPasswordLogin: "Account Password Login",
    EnterpriseWechat: "Enterprise Wechat 2.4",
    Use: "Use",
    AboveVersionScanQRcodeLogin: "Above Version Scan QR code Login",
    Or: "or",
    IncorrectFormatOfMobilePhoneNumber:
      "Incorrect format of mobile phone number！",
    PleaseInputTheGraphicVerificationCode:
      "Please input the graphic verification code！",
    ItHasToBeANumber: "It has to be a number",
    PleaseEnterAValidIDNumber: "Please enter a valid ID number.",
    EmailOrInChineseEnglishNumbersUnderscoresAndHorizontalLines:
      "Email or in Chinese, English, numbers, underscores and horizontal lines!",
    TheTwoPasswordsAreInconsistent: "The two passwords are inconsistent",
    ItHasToBe: "It has to be",
    digit: "digit",
    IsAnUnsupportedFormValidationType: "Is an unsupported form validation type",
    RegularVerificationFailed: "Regular verification failed",
    InputCannotExceed: "Input cannot exceed",
    character: "character",
    InputCannotBeLessThan: "Input cannot be less than",
    PleaseCheck: "Please check",
    LongTermValidity: "Long term validity",
    TakeEffectAfter: "Take effect after",
    Invalid: "Invalid",
    PostFailure: "Post failure",
    Disabled: "Disabled",
    NoCertification: "No certification",
    LastCertification: "Last certification",
    Password: "Password",
    QRCode: "QR code",
    fingerprint: "fingerprint",
    DynamicCode: "Dynamic Code",
    ShortMessage: "Short Message",
    Mail: "Mail",
    AbnormalError: "Abnormal error",
    VerificationCodeIsRequired: "Verification code is required",
  },

  error: {
    phoneNumber: "Wrong cell phone number",
  },

  password: {
    forgetpwd: "Forget password?",
  },

  login: {
    other: "Login in other ways",
  },

  menu: {
    ApplicationList: "Application List",
    IDHousekeeper: "ID Keeper",
    jurisdiction: "Authorization",
    Jission: "My Task",
    User: "User Information",
    password: "Change Password",
    out: "log out",
  },

  ID: {
    butler: "Binding ID keeper",
    OPEN: "Please open ID keeper",
    Scan: "Scan QR code for binding",
    Download: "ID keeper Download",
  },

  ChangePassword: {
    password: "Change Password",
    Original: "Original password",
    Original1: "Please enter the original password",
    NewPassword: "New password",
    NewPassword1: "Please enter a new password",
    confirm: "Confirm password change",
    Reconfirm: "Confirm new password",
    Reconfirm1: "Please enter the new password again",
    reset: "Reset Password",
    reset1: "Confirm Reset Password",
    Forget: "Forget password - Reset Password",
    phone: "Phone Number",
    ErrorMsg: "Wrong cell phone number",
    phone1: "Please enter your mobile phone number",
    Dynamic: "Dynamic code",
    Dynamic1: "Please input dynamic code！",
    ResetValidation: "Reset validation",
    ReturnToLogin: "Sign in",
    return: "return",
    PasswordRules: "Password rules",
    PasswordRules01:
      "1) The password must contain uppercase letters, lowercase letters and numbers",
    PasswordRules02: "2) Password length is 6-32 characters",
    PasswordRules03: "3) No account information and spaces",
    PasswordRules04:
      "4) It cannot be a common password (easy to crack), and the password cannot contain consecutive letters or numbers: 1234, 123456, 111, 2222, 12345678, etc., for example: Password1234",
    // returnclose: "Close page",
    ChangePwd: "Password modified successfully!",
    PasswordResetSucceeded: "Password reset succeeded!",
    SetMobileNumber: "Set mobile number",
    VerificationCode: "Verification code",
    VerificationCode1: "Please enter the verification code",
    MailReset: "Mail reset",
    MailBox: "Mailbox",
    MailBox1: "Please input email",
    ReturnToSelectResetMode: "Return to select reset mode",
    Next: "next step",
    register: "Register",

    already: "I have read and agree to",

    pleaseAgreement: "Please read and agree to this agreement",
    pleaseAgreement1: "Please read and check the statement below",

    read1: "I have read and agree to this agreement（5/4/3/2/1）",
    read2:
      "I have read and agree to this agreement（Slide to the bottom of the page）",
    read3: "I have read and agree to this agreement",
    userInfoPwd1: "Privacy Statement",
    userInfoPwd2: "Personal Information Authorization Statement",
  },

  user: {
    information: "User information",
    lastTime: "Last visit time",
    name: "user name",
    mail: "mailbox",
    effective: "take effect",
    attribute: "user attribute",
    Return: "Back to list",
  },

  Authorization: {
    apply: "New application",
    AuthorityDefinition: "Authority definition",
    state: "state",
    errorMessage: "error message",
    operation: "operation",
    cancel: "cancel",
  },

  AppManage: {
    add: "Add application category",
    addApp: "Add app",
    sequencing: "Application sequencing",
    addTo: "Add To",
    Del: "Delete",
    return: "<return",
    save: "save",
    name: " Classification name",
  },

  ApplicationSettings: {
    jurisdiction: "jurisdiction：",
    state: "status：",
    available: "available",
    Disable: "Disable",
    AccountStatus: "Account status：",
    AccountPeriod: "Account period",
    AddDelegation: "Add delegation",
    DelegationList: "Delegation list",
    NumberOfAccounts: "Number of accounts：",
  },
};



//////////////////
// WEBPACK FOOTER
// ./src/utiles/locale/en_US.js
// module id = 206
// module chunks = 0